window.addEventListener("load", function() {
    document.getElementById('toggle-mobile-menu').addEventListener('click', function(){
        document.body.classList.toggle('mobile-menu-open');
    })
});
